import { render, staticRenderFns } from "./ModalWI.vue?vue&type=template&id=8e23e164&scoped=true"
import script from "./ModalWI.vue?vue&type=script&lang=js"
export * from "./ModalWI.vue?vue&type=script&lang=js"
import style0 from "./ModalWI.vue?vue&type=style&index=0&id=8e23e164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e23e164",
  null
  
)

export default component.exports